import { render, staticRenderFns } from "./CardsSliderToggle.vue?vue&type=template&id=1b2fcc31&scoped=true"
import script from "./CardsSliderToggle.vue?vue&type=script&lang=js"
export * from "./CardsSliderToggle.vue?vue&type=script&lang=js"
import style0 from "./CardsSliderToggle.vue?vue&type=style&index=0&id=1b2fcc31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2fcc31",
  null
  
)

export default component.exports